import { render } from "./XmlMapperHeadList.vue?vue&type=template&id=33cca90e&scoped=true&ts=true"
import script from "./XmlMapperHeadList.vue?vue&type=script&lang=ts"
export * from "./XmlMapperHeadList.vue?vue&type=script&lang=ts"

import "./XmlMapperHeadList.vue?vue&type=style&index=0&id=33cca90e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33cca90e"]])

export default __exports__